"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.updateState = void 0;
var pagination_1 = require("./pagination");
var attributes_1 = require("./attributes");
var updateState = function (currentState, newData, usingLoadMore) {
    if (usingLoadMore === void 0) { usingLoadMore = false; }
    var paginationLowestPageIndex = newData.Pagination.CurrentPageIndex;
    var paginationFirstItemIndex = newData.Pagination.CurrentPageFirstItemIndex;
    var updatedAttributes = attributes_1.updateAttributes(newData.Filters.Attributes, currentState.attributes);
    var updatedPagination = pagination_1.updatePagination(newData.Pagination);
    for (var i = 0; i < newData.Results.length; i++) {
        if (!!newData.Results[i].Variations && newData.Results[i].Variations.length > 0) {
            for (var o = 0; o < newData.Results[i].Variations.length; o++) {
                newData.Results[i].Variations[o].addToListLinkClass = "far fa-bookmark";
            }
        }
    }
    if (usingLoadMore) {
        var changedFiltersOrSort = JSON.stringify(currentState.attributes) != JSON.stringify(updatedAttributes) // Changed a filter
            || JSON.stringify(currentState.pagination.sortOptions) != JSON.stringify(updatedPagination.sortOptions); // Changed sort order
        if (!changedFiltersOrSort) { // Only combine results when loading more
            if (JSON.stringify(currentState.results) == JSON.stringify(newData.Results)) {
                // If for some reason the results are duplicated, ignore the update
                return;
            }
            if (currentState.pagination.currentPageIndex < newData.Pagination.CurrentPageIndex) { // Load More
                paginationLowestPageIndex = currentState.paginationLowestPageIndex;
                newData.Results = currentState.results.concat(newData.Results);
            }
            else { // Load Previous
                newData.Results = newData.Results.concat(currentState.results);
                updatedPagination.currentPageIndex = currentState.pagination.currentPageIndex;
            }
            updatedPagination.currentItemsOnPage = newData.Results.length;
            paginationFirstItemIndex = Math.min(currentState.paginationFirstItemIndex, paginationFirstItemIndex);
        }
    }
    return __assign(__assign({}, currentState), { pagination: updatedPagination, paginationLowestPageIndex: paginationLowestPageIndex, paginationFirstItemIndex: paginationFirstItemIndex, attributes: updatedAttributes, results: newData.Results, searchString: newData.SearchString, additionalBlocks: newData.AdditionalBlocks });
};
exports.updateState = updateState;
